module.exports = __webpack_public_path__ + "img/026.83d19243.jpg";